import { CreditSubmission, OcaTemplate, Reference } from '@trnsact/trnsact-shared-types';
import { documentsByKey, referenceTypes, taskRegardingValues } from 'pages/Prequal/constants';
import { Account, UserProfile } from 'types';
import { checkIfDynamicReferenceSection } from 'services/dynamicOCAService';
import moment from 'moment';

export const getInsuranceTaskInput = (
  vendorOpportunityId: string,
  creditApplicationId: string,
  financeProgramId: string,
  userProfile: UserProfile,
  account: Account,
  creditSubmission: CreditSubmission,
  insuranceBroker: Reference
) => {
  return {
    vendorOpportunityId,
    creditApplicationId,
    financeProgramId,
    regarding: taskRegardingValues.insuranceVerification,
    status: 'open',
    assignedByUserProfileId: userProfile.id,
    assignedByAccountId: account.id,
    priority: 'medium',
    createdBy: userProfile.fullName,
    assignedByUser: userProfile.fullName,
    assignedByAccount: account.name,
    dueDateTime: moment().add(7, 'd').toISOString(),
    notificationContactIds: [],
    notifyAssignorOnReminder: true,
    notifyByEmail: true,

    creditSubId: creditSubmission.creditSubId,
    assignedToAccountId: creditSubmission.lenderContactInfo?.[0]?.accountId,
    assignedToUser: insuranceBroker.contactName || insuranceBroker.companyName,
    assignedToEmails: [insuranceBroker.contactEmail],
    referenceId: insuranceBroker.referenceId,
    emailTemplateId: 'd-da8bec3016f544efa0a78d6ae339ef37',
    taskItems: [
      {
        docType: documentsByKey.insurance_certificate.value,
        type: 'docs',
      },
    ],
  };
};

export const getInsuranceSectionIdx = (activeOcaTemplate: OcaTemplate): number | null => {
  if (!activeOcaTemplate) {
    return null;
  }
  const allSections = activeOcaTemplate.jsonDefinition.flatMap((page: any) => page.sections);
  const insuranceSection = allSections?.find(
    (sectionConfig: any) =>
      checkIfDynamicReferenceSection(sectionConfig) && sectionConfig.referenceType === referenceTypes.insurance
  );
  return insuranceSection?.referenceIdx ?? null;
};
